import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import {
  createCustomReportForAdvertiser,
  deleteCustomReportForAdvertiser,
  getCustomReportsForAdvertiser,
} from 'features/advertiser/async';
import { AdvertiserByIdState } from 'features/advertiser/types';
import { onFulfilled, onFulfilledDo, onPending, onRejected } from 'libs/slice';

export function customReportsCases(
  builder: ActionReducerMapBuilder<AdvertiserByIdState>
) {
  builder.addCase(
    getCustomReportsForAdvertiser.fulfilled,
    (state, { meta, payload }) => {
      onFulfilled(state.customReports, meta, meta.requestId, payload);
    }
  );

  builder.addCase(getCustomReportsForAdvertiser.pending, (state, { meta }) => {
    onPending(state.customReports, meta, false);
  });

  builder.addCase(getCustomReportsForAdvertiser.rejected, (state, { meta }) => {
    onRejected(state.customReports, meta, false);
  });

  builder.addCase(
    createCustomReportForAdvertiser.fulfilled,
    (state, { meta, payload }) => {
      onFulfilledDo(
        state.customReports,
        meta,
        meta.requestId,
        payload,
        (_, state, payload) => {
          if (payload) {
            state.data = state.data ? [...state.data, payload] : [payload];
          }
        }
      );
    }
  );

  builder.addCase(
    createCustomReportForAdvertiser.pending,
    (state, { meta }) => {
      onPending(state.customReports, meta, false);
    }
  );

  builder.addCase(
    createCustomReportForAdvertiser.rejected,
    (state, { meta }) => {
      onRejected(state.customReports, meta, false);
    }
  );

  builder.addCase(
    deleteCustomReportForAdvertiser.fulfilled,
    (state, { meta, payload }) => {
      onFulfilledDo(
        state.customReports,
        meta,
        meta.requestId,
        payload,
        (meta, state) => {
          state.data = (state.data ?? []).filter((dto) => {
            return dto.id !== meta.arg.customReportId;
          });
        }
      );
    }
  );

  builder.addCase(
    deleteCustomReportForAdvertiser.pending,
    (state, { meta }) => {
      onPending(state.customReports, meta, false);
    }
  );

  builder.addCase(
    deleteCustomReportForAdvertiser.rejected,
    (state, { meta }) => {
      onRejected(state.customReports, meta, false);
    }
  );
}
